// extracted by mini-css-extract-plugin
module.exports = {"transitionTime":"0.125","transitionTimeSeconds":"0.125s","enter":"enter_MenuSelection_2nGR7","enterActive":"enterActive_MenuSelection_3EobX"};